
import { Vue, Component, Prop } from 'vue-property-decorator';
import ProgressBar from '@/components/registration/ProgressBar.vue';

@Component({ components: { ProgressBar } })
export default class ApplicationPage extends Vue {
  @Prop({ default: 0 }) private progress: number;
}
